export class ListExternalReportBrandingsError extends Error{}